export const ORDER_STATUS = {
  pending: {
    value: "pending",
    label: "Validée",
    pluralLabel: "Validées",
    badgeClass: "bg-[#CCFF00]/20 text-[#CCFF00]",
    borderClass: "border-[#CCFF00]/30",
  },
  in_progress: {
    value: "in_progress",
    label: "En cours",
    pluralLabel: "En cours",
    badgeClass: "bg-blue-500/20 text-blue-400",
    borderClass: "border-blue-500/30",
  },
  delivered: {
    value: "delivered",
    label: "Livrée",
    pluralLabel: "Livrées",
    badgeClass: "bg-green-500/20 text-green-400",
    borderClass: "border-green-500/30",
  },
};

export const getOrderStatusMeta = (status) =>
  ORDER_STATUS[status] || {
    value: status,
    label: status || "Inconnu",
    pluralLabel: status || "Inconnu",
    badgeClass: "bg-zinc-500/20 text-zinc-400",
    borderClass: "border-white/10",
  };

export const ORDER_STATUS_ORDER = ["pending", "in_progress", "delivered"];
